export function intForGrade(grade) {
  if (grade === 'Birth-3') return -2
  if (grade === 'Pre-K') return -1
  if (grade === 'K') return 0
  if (grade === 'Adult-Transition') return 99
  return parseInt(grade)
}

export function gradeSort(grades) {
  return grades.sort((a, b) => intForGrade(a) - intForGrade(b))
}

export function gradesToLabels(grades) {
  return grades?.map((grade) => gradeLabel(grade)) || []
}

export function gradeLabel(grade) {
  if (grade === 'Adult-Transition') {
    return 'Adult Transition'
  }
  return grade
}